import Lottie from "lottie-react";
import loaderAnimation from "./loader.json";
import { cn } from "@/lib/utils";

type Props = {
  className?: string;
};

const WaveLoader = ({ className }: Props) => {
  return (
    <div className={cn("w-[180px]", className)}>
      <Lottie
        animationData={loaderAnimation}
        loop={true}
        autoplay={true}
        style={{ width: "100%", height: "100%" }}
      />
    </div>
  );
};

export default WaveLoader;
